var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectImportContactGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.448,
    height: 24,
    viewBox: "0 0 25.448 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "correct_24px",
    d: "M18.349,8.192a.9.9,0,0,1,0,1.326l-6.669,6.29a1.037,1.037,0,0,1-1.406,0L7.1,12.814a.9.9,0,0,1,0-1.326,1.037,1.037,0,0,1,1.406,0l2.472,2.331,5.966-5.627a1.037,1.037,0,0,1,1.406,0ZM25.448,12c0,6.633-5.692,12-12.724,12S0,18.632,0,12,5.692,0,12.724,0,25.448,5.368,25.448,12ZM23.46,12c0-5.6-4.8-10.125-10.736-10.125S1.988,6.4,1.988,12s4.8,10.125,10.736,10.125S23.46,17.6,23.46,12Zm0,0",
    fill: "#2ca819"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectImportContactGridIcon);
export default __webpack_public_path__ + "static/media/correct-import-contact-grid-icon.eacdebd2dadbc8a476db06ad22f368dc.svg";
export { ForwardRef as ReactComponent };